import Api from './api'

export default {
  getLastMeasurement () {
    const response = Api.get('measurement/last?did=' + process.env.DEVICE_ID)
    response.then(response => {
      response.data.t = new Date(response.data.t)
    })
    return response
  },
  getMeasurements (field) {
    const response = Api.get('measurement?did=' + process.env.DEVICE_ID + '&field=' + field)
    response.then(response => {
      response.data.forEach(element => {
        element[0] = Date.parse(element[0])
      })
    })
    return response
  }
}



// WEBPACK FOOTER //
// ./src/services/measurement.js